module.exports = __webpack_public_path__ + "static/img/erweima.6efe071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.jpg
// module id = rXaU
// module chunks = 1